import React, { useState } from 'react';
import { KatIcon } from '@amzn/katal-react';
import ToolbarButton from '../ToolbarButton';
import ImageUploadModal from './ImageUploadModal';

export type ImageButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const ImageButton: React.FC<ImageButtonProps> = (props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ToolbarButton
        data-testid="image-button"
        onClick={() => { setShowModal(true); }}
        {...props}
      >
        <KatIcon name="image" size="small" />
      </ToolbarButton>
      {showModal && (
        <ImageUploadModal onClose={() => { setShowModal(false); }} />
      )}
    </>

  );
};

export default ImageButton;
